import { i18n } from '@shared/util/i18n';
import { FilterOption, RelatedEntityPath } from '../types';

// Component ids are uuids, so this can't turn up inside one and two different paths can't produce
// the same key.
const PATH_SEPARATOR = '>';

/**
 * The key a path of `RELATED_CARD` component ids is stored under in `RelatedFilterOptions`, and
 * the prefix `getFilterOptionKey` builds on. Ordered outermost first, so one path's key is a
 * prefix of every key below it.
 */
export function getRelatedEntityPathKey(componentIds: string[]): string {
  return componentIds.join(PATH_SEPARATOR);
}

/** The component ids of `path`, outermost first. */
export function getRelatedEntityPathComponentIds(path: RelatedEntityPath | undefined): string[] {
  return (path ?? []).map(hop => hop.componentId);
}

/**
 * The path a filter nested *below* `option` would travel: the hops that already lead to `option`,
 * plus `option`'s own component. Only meaningful for a `RELATED_CARD` option - see `isExpandable`.
 */
export function getFilterOptionRelatedPath(option: FilterOption): string[] {
  return [...getRelatedEntityPathComponentIds(option.relatedEntityPath), option.id];
}

/**
 * How a cross-workflow filter reads: the path it travels, "Asset → Meter → Status", so it's clear
 * the field belongs to a related card rather than this workflow. One hop or five, the separator is
 * the same, so this just folds the labels together. A filter with no hops reads as `label` alone.
 */
export function getRelatedEntityPathLabel(
  path: RelatedEntityPath | undefined,
  label: string,
): string {
  return [...(path ?? []).map(hop => hop.label), label].reduce((traversed, next) =>
    i18n('card.actions.filters.relatedFieldLabel', { relatedLabel: traversed, label: next }),
  );
}
